import { SpendChipsRows } from "@/components/home/spend-chips-rows";
import {
  TERMS_BOTTOM_CARD_HEIGHT,
  TERMS_BOTTOM_CARD_PADDING,
} from "@/components/home/terms-card-spacing";
import { liveHomeCopy as enLiveHomeCopy } from "@/content/pages/en/live-home";
import { cn } from "@/lib/utils";

import { CardLede } from "./card-lede";
import type { TermsCopy } from "./types";

/** "No spend restrictions" — bleeding rows of category chips that fade out.
 * Rows are absolutely positioned at their exact Figma coordinates (the group
 * isn't auto-layout, so the vertical gaps are uneven). */
export function StaticSpendCard({
  copy = enLiveHomeCopy.terms,
}: {
  copy?: TermsCopy;
}) {
  return (
    // Mobile (Figma 5948:28542): 24px padding; desktop 32px.
    <div
      className={cn(
        "border-grey-100 bg-grey-0 relative overflow-hidden rounded-2xl border",
        TERMS_BOTTOM_CARD_HEIGHT,
        TERMS_BOTTOM_CARD_PADDING
      )}
    >
      <CardLede
        lead={copy.spendLead}
        rest={copy.spendRest}
        className="max-w-[304px]"
        data-testid="terms-spend-title"
      />

      <SpendChipsRows />
    </div>
  );
}
